import type { RouteLocationNormalized } from 'vue-router';
import { useCardAvailability } from '@/shared/smartCard/composables/useCardAvailability';

/**
 * Guard para validar que el país del usuario tenga habilitado el módulo de tarjetas.
 * Redirige a la página de movimientos si el país no está en la lista de países habilitados.
 * No distingue mayúsculas: `/CARD` se trata igual que `/card`.
 */
export function validateCardCountryAvailability(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized
) {
  if (!to.path.toLowerCase().startsWith('/card')) {
    return true;
  }

  const { isCardAvailableForCountry } = useCardAvailability();

  if (!isCardAvailableForCountry.value) {
    return { name: 'movements' };
  }

  return true;
}
